{
  "apiUrl": "https://sea-emt-dev-api.ap.manulife.com/ext/dot-kh-bff",
  "ptkUrl": "/dev/pay",
  "isMock": true
}
